"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)("path", {
      fill: "currentColor",
      d: "M20.696 19.427a6.253 6.253 0 0 0-2.447-9.442 7.146 7.146 0 1 0-12.675 5.62l-1.242 1.232a.893.893 0 0 0-.187.974.893.893 0 0 0 .821.553h5.083a6.253 6.253 0 0 0 5.636 3.573h5.36a.893.893 0 0 0 .822-.553.893.893 0 0 0-.188-.974l-.983-.983zM9.433 15.685c0 .299.025.597.071.893H7.119l.313-.304a.893.893 0 0 0 0-1.268 5.297 5.297 0 0 1-1.572-3.788c0-2.96 2.4-5.36 5.36-5.36a5.306 5.306 0 0 1 5.046 3.574h-.58a6.253 6.253 0 0 0-6.253 6.253zm9.414 4.466.045.045h-3.207a4.466 4.466 0 1 1 3.162-1.305.893.893 0 0 0-.268.626.893.893 0 0 0 .268.634z"
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=ChatDuoOutlined.js.map